var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { Children } from "react";
import classNames from "classnames";
import "@gouvfr/dsfr/dist/component/link/link.css";
import "@gouvfr/dsfr/dist/component/skiplink/skiplink.css";
var SkipLinks = function (props) {
    var _a = props.ariaLabel, ariaLabel = _a === void 0 ? "Accès rapide" : _a, children = props.children, className = props.className, remainingProps = __rest(props, ["ariaLabel", "children", "className"]);
    var content = Children.toArray(children).map(function (child, index) { return (React.createElement("li", { key: index }, child)); });
    return (React.createElement("div", __assign({ className: classNames("fr-skiplinks", className) }, remainingProps),
        React.createElement("nav", { className: "fr-container", role: "navigation", "aria-label": ariaLabel },
            React.createElement("ul", { className: "fr-skiplinks__list" }, content))));
};
export default SkipLinks;
